"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationContract = void 0;
const core_1 = require("@ts-rest/core");
const locations_request_1 = require("./locations.request");
const locations_response_1 = require("./locations.response");
const c = (0, core_1.initContract)();
exports.LocationContract = c.router({
    district: c.router({
        list: {
            method: 'GET',
            path: '/',
            query: locations_request_1.DistrictListQuerySchema.optional(),
            responses: { 200: locations_response_1.DistrictListResponseSchema },
        },
    }, { pathPrefix: '/districts' }),
    province: c.router({
        list: {
            method: 'GET',
            path: '/',
            query: locations_request_1.ProvinceListQuerySchema.optional(),
            responses: { 200: locations_response_1.ProvinceListResponseSchema },
        },
    }, { pathPrefix: '/provinces' }),
}, { pathPrefix: '/locations' });
